import React from 'react';
import { Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';

import { setAutoSelectInstancesForNextBundle } from '../../../actions/bundleActions';
import { CREATE_OR_ADD_TO_BUNDLE_QUANTITIES } from '../../../actions/dialogActions';
import { getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab } from '../../../selectors/getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab';
import { getOrderedCheckedAnalysisSetGuidsForUnbundled } from '../../../selectors/productionGroupGrid';
import { showPopup } from '../../../store/popupSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function CreateOrAddToBundleButton() {
  const dispatch = useAppDispatch();
  const orderedCheckedAnalysisSetGuidsForUnbundled = useAppSelector(getOrderedCheckedAnalysisSetGuidsForUnbundled);
  const productionComponentInstancesForActiveProductionGroup = useAppSelector(
    getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab,
  );
  const bundleBeingEditedGuid = useAppSelector((state) => state.batchesAndBundlesTab.bundleBeingEditedGuid);
  const autoSelectNextWhenBundling = useAppSelector((state) => state.batchesAndBundlesTab.autoSelectNextWhenBundling);

  const areUnbatchedComponents = productionComponentInstancesForActiveProductionGroup.some(
    (productionComponentInstance) => productionComponentInstance.batchGuid === null,
  );
  const tooltipText = areUnbatchedComponents
    ? 'Batch all components before creating bundles'
    : orderedCheckedAnalysisSetGuidsForUnbundled.length === 0
      ? 'Check components in the grid to create/add to a bundle'
      : null;

  return (
    <>
      <Tooltip disableInteractive title={tooltipText}>
        <span>
          <Button
            variant="outlined"
            sx={{ mr: 1 }}
            onClick={() => void dispatch(showPopup(CREATE_OR_ADD_TO_BUNDLE_QUANTITIES))}
            disabled={areUnbatchedComponents || orderedCheckedAnalysisSetGuidsForUnbundled.length === 0}
          >
            {bundleBeingEditedGuid !== null ? 'Add to Bundle' : 'Create Bundle'}
          </Button>
        </span>
      </Tooltip>
      <FormControlLabel
        control={
          <Checkbox
            checked={autoSelectNextWhenBundling}
            onChange={(event) => void dispatch(setAutoSelectInstancesForNextBundle(event.target.checked))}
          />
        }
        label="Auto-select next"
      />
    </>
  );
}
